import _ from 'lodash';

const parseComponents = (components) => {
  const address = {};
  const componentMapping = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    sublocality_level_1: 'long_name',
    administrative_area_level_1: 'short_name',
    postal_code: 'short_name',
    country: 'short_name',
  };
  components.forEach((component) => {
    const type = component.types[0];
    if (componentMapping[type]) {
      const val = component[componentMapping[type]];
      address[type] = val;
    }
    address.number_and_route = _.compact([
      address.street_number,
      address.route,
    ]).join(' ');
  });
  if (!address.locality && address.sublocality_level_1) {
    address.locality = address.sublocality_level_1;
  }
  return address;
};

export default {
  parseComponents,
};



// WEBPACK FOOTER //
// ./src/utils/maps.js